(() => {
  angular
    .module('finance')
    .controller('curlecPayoutAccountEnquiryModal', CurlecPayoutAccountEnquiryModal);

  CurlecPayoutAccountEnquiryModal.$inject = [
    '$uibModalInstance',
    'abp.services.finance.curlecPayout',
  ];

  function CurlecPayoutAccountEnquiryModal($uibModalInstance, curlecPayoutSvc) {
    const vm = this;

    vm.loading = 0;
    vm.pageState = 0;
    vm.result = null;
    vm.parameters = {
      enquiryType: 0,
      thirdPartyAccountNo: '',
      thirdPartyBankBICCode: '',
    };

    vm.accountEnquiry = accountEnquiry;
    vm.back = back;
    vm.close = close;
    init();

    function init() {}

    function accountEnquiry() {
      let input = $.extend({}, vm.parameters);

      vm.pageState = 1;

      vm.loading += 1;
      curlecPayoutSvc
        .accountEnquiry(input)
        .success((data) => {
          vm.result = JSON.stringify(data.response, null, 2);
        })
        .finally(() => {
          vm.loading -= 1;
        });
    }

    function back() {
      vm.pageState = 0;
      vm.result = null;
    }

    function close() {
      $uibModalInstance.dismiss();
    }
  }
})();
